// import ApiUtils from '@/utils/api/ApiUtils'
import ObjArrUtils from '@/utils/ObjArrUtils'
import { Base, BREAD, error } from '@/store/base/module'

const PageConst= {
  ACTION: {
    doAdd: { api: 'M1031MailSettingService.M20701_doAdd'},
    getEdit: { api: 'M1031MailSettingService.M20701_getEdit'},
    doEdit: { api: 'M1031MailSettingService.M20701_doEdit'},
    doRead: { api: 'M1031MailSettingService.M20701_doRead'},
    doDelete: { api: 'M1031MailSettingService.M20701_doDelete'},
    doBrowse: { api: 'M1031MailSettingService.M20701_doBrowse'},
  },
}

const module = {
  state: {
    PageConst,
    dropdownList: {
      notification_type: [
        { label: '追加申込', value: 1 },
        { label: '講習申込', value: 2 },
        { label: '振替申込', value: 3 }
      ]
    },
    notificationTypeData: {
      // 追加申込
      1: {
        availableVariables:[
          { label: '学生氏名', placeholder: '{# $Name #}' },
          { label: '教室ID', placeholder: '{# $ClassRoomID #}' },
          { label: '学年', placeholder: '{# $Grade #}' },
          { label: 'コース名', placeholder: '{# $Course #}' },
          { label: '申し込み回数', placeholder: '{# $ApplicateCount #}' },
          { label: '申し込み情報', placeholder: '{# $ApplicateInfo #}' },
          { label: '授業に関するご要望', placeholder: '{# $Request #}' }
        ],
        Name: 'WAM太郎',
        Grade: '小６',
        ClassRoomID: 'h001',
        Course: '40分(後半)',
        ApplicateCount: 2,
        ApplicateInfo: '科目：国語ｱﾄﾞﾊﾞﾝｽ&nbsp;&nbsp;小６&nbsp;&nbsp;１:１<br />&nbsp;07/17(木)&nbsp;6講（後半）&nbsp;(19:10~19:50)<br />科目：数(算)ｱﾄﾞﾊﾞﾝｽ&nbsp;&nbsp;小６&nbsp;&nbsp;１:１<br />&nbsp;07/18(金)&nbsp;6講（後半）&nbsp;(19:10~19:50)<br />',
        Request: 'Test Request',
      },
      // 講習申込
      2: {
        availableVariables:[
          { label: '学生氏名', placeholder: '{# $Name #}' },
          { label: '教室ID', placeholder: '{# $ClassRoomID #}' },
          { label: '学年', placeholder: '{# $Grade #}' },
          { label: 'コース名', placeholder: '{# $Course #}' },
          { label: '申し込み回数', placeholder: '{# $ApplicateCount #}' },
          { label: '申し込み情報', placeholder: '{# $ApplicateInfo #}' },
          { label: '授業に関するご要望', placeholder: '{# $Request #}' }
        ],
        Name: 'WAM太郎',
        Grade: '小６',
        ClassRoomID: 'h001',
        Course: '40分(前半)',
        ApplicateCount: 2,
        ApplicateInfo: '科目：国語ｱﾄﾞﾊﾞﾝｽ&nbsp;&nbsp;小６&nbsp;&nbsp;１:１<br />&nbsp;07/17(木)&nbsp;7講（前半）&nbsp;(20:00~20:40)[追加]<br />科目：数(算)ｱﾄﾞﾊﾞﾝｽ&nbsp;&nbsp;小６&nbsp;&nbsp;１:１<br />&nbsp;07/18(金)&nbsp;7講（前半）&nbsp;(20:00~20:40)[追加]<br />',
        Request: 'Test Request',
      },
      // 振替申込
      3: {
        availableVariables:[
          { label: '学生氏名', placeholder: '{# $Name #}' },
          { label: '教室ID', placeholder: '{# $ClassRoomID #}' },
          { label: '振替科目名', placeholder: '{# $CurriculumName #}' },
          { label: '振替前の情報', placeholder: '{# $BeforeApplicate #}' },
          { label: '振替後の情報', placeholder: '{# $AfterApplicate #}' },
          { label: '学年', placeholder: '{# $Grade #}' },
          { label: 'コース名', placeholder: '{# $Course #}' },
          { label: '申し込み回数', placeholder: '{# $ApplicateCount #}' },
          { label: '申し込み情報', placeholder: '{# $ApplicateInfo #}' },
          { label: '授業に関するご要望', placeholder: '{# $Request #}' }
        ],
        Name: 'WAM太郎',
        Grade: '小６',
        ClassRoomID: 'h001',
        Course: '40分(後半)',
        CurriculumName: '数(算)ｱﾄﾞﾊﾞﾝｽ',
        BeforeApplicate: '2025/08/27&nbsp;水&nbsp;5講（後半）&nbsp;',
        AfterApplicate: '2025/07/15&nbsp;火&nbsp;7講（後半）&nbsp;',
        ApplicateCount: 0,
        Request: 'Test Request',
      }
    }
  },

  getters: {},

  mutations: {},

  actions: {
    async M20701_doBrowse_init ({ state, commit, rootState,dispatch }) {
      return await dispatch('M20701_doBrowse_AtDataTable');
    },
    async M20701_doBrowse_AtDataTable({dispatch, state}) {
      return await dispatch('doBrowse_AtDataTable', {
        orderBy: state.orderBy,
        pagination: state.pagination
      });
    },
    // async M20701_exportCSV ({ state }) {
    //   const res = await ApiUtils.postData({
    //     data: [{
    //       api: 'M1031MailSettingService.M20701_exportCSV',
    //       input: { searchInfo: state.searchInfo }
    //     }]
    //   })
    //   return res[0].output;
    // },
  }
}

export default ObjArrUtils.merge(Base, error, BREAD, module)
